import { createBrowserRouter } from 'react-router-dom';
import { useEffect, lazy, Component } from 'react';
import { useLocation } from 'react-router-dom';

import { removeLine } from '@/utils';

const Test = lazy(() => import('@/pages/test'));
const Test1 = lazy(() => import('@/pages/test1'));
const Test2 = lazy(() => import('@/pages/test2'));
const Test3 = lazy(() => import('@/pages/test3'));
const Test4 = lazy(() => import('@/pages/test4'));
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const IogIn = lazy(() => import('@/pages/Dashboard/pages/IogIn'));
const Register = lazy(() => import('@/pages/Dashboard/pages/Register'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const SystemError = lazy(() => import('@/pages/SystemError'));
const Terminal = lazy(() => import('@/pages/Terminal'));

// const UseOverview = lazy(() => import('@/pages/Dashboard/pages/UseOverview'));
// const NodeConfig = lazy(() => import('@/pages/Dashboard/pages/NodeConfig'));
// const NodeSet = lazy(() => import('@/pages/Dashboard/pages/NodeSet'));
// const TransactionRecord = lazy(() => import('@/pages/Dashboard/pages/TransactionRecord'));
// const ActivationRecord = lazy(() => import('@/pages/Dashboard/pages/ActivationRecord'));
// const Meter = lazy(() => import('@/pages/Dashboard/pages/Meter'));
// const ClusterManagement = lazy(() => import('@/pages/Dashboard/pages/ClusterManagement'));

// const ClusterManagementDetails = lazy(() => import('@/pages/Dashboard/pages/ClusterManagement/details'));
const Home = lazy(() => import('@/pages/Dashboard/pages/Home'));
const Chat = lazy(() => import('@/pages/Dashboard/pages/Chat'));
const VideoTool = lazy(() => import('@/pages/Dashboard/pages/AiTool/Video'));
const VideoToolDetails = lazy(() => import('@/pages/Dashboard/pages/AiTool/Video/Details'));

const ImgTool = lazy(() => import('@/pages/Dashboard/pages/AiTool/Img'));
const ImgToolDetails = lazy(() => import('@/pages/Dashboard/pages/AiTool/Img/Details'));

const Subscription = lazy(() => import('@/pages/Dashboard/pages/Subscription'));
const Asset = lazy(() => import('@/pages/Dashboard/pages/Asset'));
// const Node = lazy(() => import('@/pages/Node')); // lazy(() => import('@/pages/Node'));
const EditorList = lazy(() => import('@/components/EditorList')); // lazy(() => import('@/pages/Node'));

const UserSettings = lazy(() => import('@/pages/Dashboard/pages/UserSettings'));

// const TokenDistribution = lazy(() => import("@/pages/TokenDistribution"));

// 封装 ScrollToTop 功能
const ScrollToTopWrapper = ({ children }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        // 每次路由变化时滚动到顶部
        window.scrollTo(0, 0);
    }, [pathname]);

    return children;
};

const config = [
    // {
    //     path: '/',
    //     name: 'index',
    //     element: (
    //         <ScrollToTopWrapper>
    //             <Dashboard />
    //         </ScrollToTopWrapper>
    //     ),
    // },

    {
        Component: Dashboard,
        path: '/',
        name: 'dashboard',
        exact: true,
        children: [
            {
                path: 'log-in',
                name: 'logIn',
                Component: IogIn,
                exact: true,
            },
            {
                path: 'register',
                name: 'register',
                Component: Register,
                exact: true,
            },

            // {
            //     path: 'use-overview',
            //     name: 'useOverview',
            //     Component: UseOverview,
            // },

            // {
            //     path: 'cluster-management',
            //     name: 'clusterManagement',
            //     Component: ClusterManagement,
            // },

            // {
            //     path: 'cluster-management/details/:id',
            //     name: 'clusterManagementDetails',
            //     Component: ClusterManagementDetails,
            // },

            // {
            //     path: 'meter/:id?',
            //     name: 'meter',
            //     Component: Meter,
            // },
            // {
            //     path: 'node-config/:action/:id?',
            //     name: 'nodeConfig',
            //     Component: NodeConfig,
            // },

            // {
            //     path: 'node-set/:action/:id?',
            //     name: 'nodeSet',
            //     Component: NodeSet,
            // },

            // {
            //     path: 'activation-record',
            //     name: 'activationRecord',
            //     Component: ActivationRecord,
            //     exact: true,
            // },

            // {
            //     path: 'transaction-record',
            //     name: 'transactionRecord',
            //     Component: TransactionRecord,
            // },

            {
                path: 'home',
                name: 'home',
                Component: Home,
            },
            {
                path: 'chat',
                name: 'chat',
                Component: Chat,
                exact: true,
            },

            {
                path: 'ai-tool/img-details/:id',
                name: 'imgToolDetails',
                Component: ImgToolDetails,
                exact: true,
            },

            {
                path: 'ai-tool/img/:id?',
                name: 'imgTool',
                Component: ImgTool,
                exact: true,
            },

            // {
            //     path: 'img-tool/:id?',
            //     name: 'imgTool',
            //     Component: ImgTool,
            //     exact: true,
            // },

            {
                path: 'ai-tool/video-details/:id',
                name: 'videoToolDetails',
                Component: VideoToolDetails,
                exact: true,
            },

            {
                path: 'ai-tool/video/:id?',
                name: 'videoTool',
                Component: VideoTool,
                exact: true,
            },

            {
                path: 'asset',
                name: 'asset',
                Component: Asset,
                exact: true,
            },
            {
                path: 'subscription',
                name: 'subscription',
                Component: Subscription,
                exact: true,
            },

            {
                path: 'user-settings',
                name: 'userSettings',
                Component: UserSettings,
                exact: true,
            },

            // IogIn
        ],
    },
    {
        path: 'test', // 匹配所有未定义的路径
        name: 'test',
        element: <Test />, // 使用上面定义的404组件
        exact: true,
    },
    {
        path: 'editor-list', // 匹配所有未定义的路径
        name: 'editorList',
        element: <EditorList />, // 使用上面定义的404组件
        exact: true,
    },

    {
        path: 'test1', // 匹配所有未定义的路径
        name: 'test1',
        element: <Test1 />, // 使用上面定义的404组件
        exact: true,
    },

    {
        path: 'test2', // 匹配所有未定义的路径
        name: 'test2',
        element: <Test2 />, // 使用上面定义的404组件
        exact: true,
    },

    {
        path: 'test3', // 匹配所有未定义的路径
        name: 'test3',
        element: <Test3 />, // 使用上面定义的404组件
        exact: true,
    },

    {
        path: 'test4', // 匹配所有未定义的路径
        name: 'test4',
        element: <Test4 />, // 使用上面定义的404组件
        exact: true,
    },
    // {
    //     path: 'node', // 匹配所有未定义的路径
    //     name: 'node',
    //     element: <Node />, // 使用上面定义的404组件
    //     exact: true,
    // },

    // 👇 重点：在路由数组最后添加404兜底路由
    {
        path: 'system-error/:type', // 匹配所有未定义的路径
        name: 'systemError',
        element: <SystemError />, // 使用上面定义的404组件
        exact: true,
    },

    {
        path: '/terminal',
        name: 'terminal',
        exact: true,
        element: (
            <ScrollToTopWrapper>
                <Terminal />
            </ScrollToTopWrapper>
        ),
    },

    // 👇 重点：在路由数组最后添加404兜底路由
    {
        path: '*', // 匹配所有未定义的路径
        name: 'notFound',
        element: <NotFound />, // 使用上面定义的404组件
    },
];

const getroutePaths = (data, paths = {}, parentPath = '') => {
    for (const item of data) {
        let { path = '', children, name } = item;
        path = '/' + path;
        // 第一层
        if (children && children.length) {
            paths[name] = removeLine(parentPath + path);
            getroutePaths(children, paths, path);
        } else {
            paths[name] = removeLine(parentPath + path);
        }
    }

    return paths;
};

export const routePaths = getroutePaths(config);

export default config;
